module.exports = __webpack_public_path__ + "static/media/opensans-regular.1510a83c.woff";